export enum CardAccountType {
  ASSET_LINK = 'asset-link',
  PREPAID = 'prepaid',
  FIXED_LIMIT = 'fixed-limit'
}

export enum KycStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PENDING_APPROVAL = 'PENDING_APPROVAL'
}

export enum CardAccountTypeColor {
  'asset-link' = 'Blue',
  'prepaid' = 'Cyan',
  'fixed-limit' = 'Green'
}

export enum KycStatusColor {
  'APPROVED' = 'Green',
  'REJECTED' = 'Red',
  'PENDING_APPROVAL' = 'Grey'
}
